import { render, staticRenderFns } from "./NotificationProfileList.vue?vue&type=template&id=2a3f62c2&scoped=true&"
import script from "./NotificationProfileList.vue?vue&type=script&lang=js&"
export * from "./NotificationProfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3f62c2",
  null
  
)

export default component.exports